import { TimelineUpdateStatus, type UpdateProgress } from '../store/schemas'

export type ActiveTimelineUpdateStatus =
  | TimelineUpdateStatus.PENDING
  | TimelineUpdateStatus.EXTRACTING
  | TimelineUpdateStatus.MERGING
  | TimelineUpdateStatus.FINALIZING

export function isActiveTimelineUpdateStatus(status: TimelineUpdateStatus): status is ActiveTimelineUpdateStatus {
  switch (status) {
    case TimelineUpdateStatus.PENDING:
    case TimelineUpdateStatus.EXTRACTING:
    case TimelineUpdateStatus.MERGING:
    case TimelineUpdateStatus.FINALIZING:
      return true
    case TimelineUpdateStatus.DONE:
    case TimelineUpdateStatus.FAILED_FILES:
    case TimelineUpdateStatus.ERROR:
      return false
    default:
      status satisfies never
      return false
  }
}

// Stage word plus, during EXTRACTING only, a live "N of M files" count from the polled progress
// (ENG-7004). Extraction is the only per-file stage; PENDING/MERGING/FINALIZING have no
// meaningful denominator, so they keep the bare stage word.
export function activeStatusLabel(status: ActiveTimelineUpdateStatus, progress?: UpdateProgress): string {
  switch (status) {
    case TimelineUpdateStatus.PENDING:
      return 'Queued...'
    case TimelineUpdateStatus.EXTRACTING: {
      // progress is missing before the first poll lands, and files_total is 0 until the worker
      // claims the run — fall back to the bare stage word in both windows.
      if (!progress || progress.files_total <= 0) return 'Extracting...'
      const done = Math.min(Math.max(progress.files_extracted + progress.files_included + progress.files_failed, 0), progress.files_total)
      return `Extracting... ${done} of ${progress.files_total} ${progress.files_total === 1 ? 'file' : 'files'}`
    }
    case TimelineUpdateStatus.MERGING:
      return 'Merging...'
    case TimelineUpdateStatus.FINALIZING:
      return 'Finalizing...'
    default:
      status satisfies never
      return 'Queued...'
  }
}
